import { ITemplateStylingSettings } from '@/components/settings-page/platformSettings/templatesSettings/types';
import { getCacheBustedFileUrl } from '@/components/settings-page/utils';
import { Image as PdfImage, View } from '@react-pdf/renderer';
import { DefaultTheme } from 'styled-components/dist/types';
import { templateStyles } from '../style';

interface PDFTemplateHeaderProps {
  templateStylingData: ITemplateStylingSettings;
  theme: DefaultTheme;
}

export const PDFTemplateHeader = ({ templateStylingData, theme }: PDFTemplateHeaderProps) => {
  return (
    <>
      <View
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '5px',
          backgroundColor: templateStylingData?.accentColor || '#5A6771'
        }}
        fixed
      />
      <View style={{ ...templateStyles.headerWrap, backgroundColor: theme.layer[12] }} fixed>
        <View style={templateStyles.logoWrap}>
          {templateStylingData?.logo ? <PdfImage style={templateStyles.logoImg} src={getCacheBustedFileUrl(templateStylingData?.logo)} /> : null}
        </View>
      </View>
    </>
  );
};
